module.exports = __webpack_public_path__ + "img/background_c3-2-2.331d2d02.jpg";